/**
*  @class
*  @function FreeShippingProgressBar
*/


if (!customElements.get('free-shipping-progress-bar')) {
   let currentPercent = 0; // Store the current percentage globally
   class FreeShippingProgressBar extends HTMLElement {
     constructor() {
       super();
     }
      connectedCallback() {
       this.updateStatus();
     }
      updateStatus() {
       const remainingAmountText = this.querySelector('.free-shipping__info-remaining strong');
       const cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
       const freeShippingThreshold = Math.round(parseInt(this.dataset.shippingAmount, 10) * (Shopify.currency.rate || 1));
       const remainingInfo = this.querySelector('.free-shipping__info-remaining');
       const eligibilityInfo = this.querySelector('.free-shipping__info-eligibility');
       const isEligible = cartTotal >= freeShippingThreshold;
        if (remainingAmountText && !isEligible) {
         const remainingAmount = freeShippingThreshold - cartTotal;
         const currencyFormat = window.theme.settings.money_with_currency_format || "${{amount}}";
         remainingAmountText.innerHTML = formatMoney(remainingAmount, currencyFormat);
       }
        remainingInfo.style.display = isEligible ? 'none' : 'block';
       eligibilityInfo.style.display = isEligible ? 'block' : 'none';
        const progressPercentage = isEligible ? 1 : cartTotal / freeShippingThreshold;
       this.animateProgressBar(progressPercentage);


       if (!isEligible) {
         sessionStorage.removeItem('confetti-celebrated');
       }
     }
      animateProgressBar(progressPercentage) {
       const targetPercent = progressPercentage * 100;
       const startPercent = currentPercent;
       const duration = 200;
       const startTime = performance.now();
        const ease = (t) => t * (2 - t);
        const animate = (time) => {
         const elapsed = time - startTime;
         const progress = Math.min(elapsed / duration, 1);
         const easedProgress = ease(progress);
          currentPercent = startPercent + (targetPercent - startPercent) * easedProgress;
         this.style.setProperty('--percent', `${currentPercent}%`);
          if (progress < 1) {
           requestAnimationFrame(animate);
         } else {
           currentPercent = targetPercent;
           this.style.setProperty('--percent', `${currentPercent}%`);


           const hasCelebrated = sessionStorage.getItem('confetti-celebrated');
           if (currentPercent === 100 && !hasCelebrated) {
             sessionStorage.setItem('confetti-celebrated', 'true');
             setTimeout(() => this.launchConfetti(), 300);
           }
         }
       }; 
      requestAnimationFrame(animate);
   }
  
     launchConfetti() {
     let canvas = document.querySelector("canvas.confetti-canvas");
     if (!canvas) {
       canvas = document.createElement("canvas");
       canvas.classList.add("confetti-canvas");
       canvas.style.position = "fixed";
       canvas.style.top = "0";
       canvas.style.left = "0";
       canvas.style.width = "100vw";
       canvas.style.height = "100vh";
       canvas.style.pointerEvents = "none";
       canvas.style.zIndex = "99999";
       document.body.appendChild(canvas);
     }


       try {
       const myConfetti = confetti.create(canvas, {
         resize: true,
         useWorker: true
       });
      
       const duration = 1000;
       const end = Date.now() + duration;


       const frame = () => {
         myConfetti({
           particleCount: Math.random() > 0.5 ? 10 : 3,
           spread: 360,
           origin: { x: Math.random(), y: Math.random() * 0.6 }
         });
        
         if (Date.now() < end) {
           requestAnimationFrame(frame);
         } else {
           setTimeout(() => {
             if (canvas && canvas.parentNode) {
               canvas.style.transition = "opacity 0.3s ease";
               canvas.style.opacity = "0";
               setTimeout(() => {
                 if (canvas && canvas.parentNode) {
                   canvas.remove();
                 }
               }, 300);
             }
           }, 1000);
         }
       };


       frame();
      
     } catch (error) {
       console.error('Confetti error:', error);
       if (canvas && canvas.parentNode) {
         canvas.remove();
       }
     }
   }
 }


   customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
}

